@if (isLoading()) {
    <div class="flex flex-row items-center justify-center w-full h-full p-8">
        <k-loading class="min-h-[400px] flex flex-row items-center justify-center" />
    </div>
} @else {
    <div class="flex flex-col justify-center items-center p-8">
        <div class="flex flex-col items-center container-item">
            <h3 class="flex flex-row items-center justify-center m-0 p-0 rating-title">
                {{ 'ORDER_DETAIL_MODAL_RATING.RATING_AVERAGE' | translate }}
            </h3>
            <span class="flex flex-row items-center justify-center rating-value">{{ renderOrderRating().ratingValue }}</span>
        </div>
        @for (rating of renderOrderRating().ratings; track rating.id) {
            <div class="flex flex-col items-center container-item">
                <h3 class="flex flex-row items-center justify-center m-0 p-0 rating-title">{{ rating.ratingType?.name }}</h3>
                <div class="flex flex-row items-center justify-center kw-stars-unit mt-[10px]">
                    @for (percentage of rating.percentage; track percentage) {
                        <div class="start-item">
                            <span class="star-active" [style.width]="percentage">
                                <mat-icon>star</mat-icon>
                            </span>
                            <span class="star-inactive">
                                <mat-icon>star</mat-icon>
                            </span>
                        </div>
                    }
                </div>
            </div>
        }
        @if (renderOrderRating().note) {
            <div class="break-line mb-4"></div>
            <div class="flex flex-col items-center justify-center container-item mb-0">
                <h3 class="m-0 p-0 rating-title">{{ 'ORDER_DETAIL_MODAL_RATING.DESCRIPTION' | translate }}</h3>
                <span class="mt-1">{{ renderOrderRating().note }}</span>
            </div>
        }
    </div>
}
